export function mapFieldBasedOnCondition(arr, existingKey, newKey, condition) {
  return arr.map((obj) => {
    // Spread operator to avoid mutation of the original object
    let newObj = {...obj}

    // Apply the condition based on the existing key
    newObj[newKey] = condition(newObj[existingKey])

    return newObj
  })
}
